export interface ProfileDefaultsInput {
  email?: string;
  metadataTitle?: string;
}

export interface ProfileDefaults {
  email: string;
  firstName: string;
  lastName: string;
  displayName: string;
  title: string;
}

export type ProfileAvatarDisplay =
  | { kind: 'image'; src: string }
  | { kind: 'initials'; initials: string };

export function getProfileDefaults(input: ProfileDefaultsInput): ProfileDefaults {
  const email = input.email || 'local@parcel.dev';

  return {
    email,
    firstName: '',
    lastName: '',
    displayName: '',
    title: input.metadataTitle?.trim() || '',
  };
}

export function getProfileInitials(input: {
  displayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
}): string {
  const source =
    input.displayName?.trim() ||
    [input.firstName, input.lastName].filter(Boolean).join(' ').trim() ||
    input.email.replace(/@.*/, '');
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  const [first = 'U', second] = parts;
  return (second ? `${first.charAt(0)}${second.charAt(0)}` : first.slice(0, 2)).toUpperCase();
}

export function getProfileAvatarDisplay(
  avatarUrl: string | null,
  input: {
    displayName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
  },
): ProfileAvatarDisplay {
  if (avatarUrl) return { kind: 'image', src: avatarUrl };
  return { kind: 'initials', initials: getProfileInitials(input) };
}
